import {
  faCcAmex,
  faCcJcb,
  faCcMastercard,
  faCcVisa,
  faCcDiscover,
  faCcDinersClub,
} from '@fortawesome/free-brands-svg-icons';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Brand({ type, isCheckout = false, ...props }: { type: string; isCheckout?: boolean; props?: any }) {
  if (!type) {
    return <FontAwesomeIcon size="2x" icon={faCreditCard} width={isCheckout ? 24 : 32} />;
  }
  if (type.toLowerCase() === 'visa')
    return <FontAwesomeIcon size="2x" icon={faCcVisa} {...props} width={isCheckout ? 24 : 32} />;
  if (type.toLowerCase() === 'mastercard' || type.toLowerCase() === 'master-card')
    return <FontAwesomeIcon size="2x" icon={faCcMastercard} width={isCheckout ? 24 : 32} />;
  if (type.toLowerCase() === 'jcb')
    return <FontAwesomeIcon size="2x" icon={faCcJcb} width={isCheckout ? 24 : 32} />;
  if (type.toLowerCase() === 'amex')
    return <FontAwesomeIcon size="2x" icon={faCcAmex} width={isCheckout ? 24 : 32} />;
  if (type.toLowerCase() === 'discover')
    return <FontAwesomeIcon size="2x" icon={faCcDiscover} width={isCheckout ? 24 : 32} />;
  if (type.toLowerCase() === 'diners')
    return <FontAwesomeIcon size="2x" icon={faCcDinersClub} width={isCheckout ? 24 : 32} />;
  return <FontAwesomeIcon size="2x" icon={faCreditCard} width={isCheckout ? 24 : 32} />;
}

export default Brand;
